export enum MultiangebotAdressenValidationResult {
  RISIKOORT_BEREITS_VERSICHERT = 'RISIKOORT_BEREITS_VERSICHERT',
  VORVERTRAG_WITH_SAME_ADRESS_EXISTS = 'VORVERTRAG_WITH_SAME_ADRESS_EXISTS',
}
